import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";

export default function ShopBar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Show the bar only once the user has scrolled past the pinned hero
    // (i.e. the TriDelivery section is entering the viewport). This prevents
    // the sticky bar from overlapping the hero's own submit button on mobile.
    const target = document.querySelector('[data-testid="tridelivery-section"]');
    if (!target) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        // once tridelivery has any portion above the fold, keep it shown
        setShow(entry.isIntersecting || entry.boundingClientRect.top < 0);
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0 },
    );
    io.observe(target);
    return () => io.disconnect();
  }, []);

  const toWaitlist = () => {
    if (window.lenis) window.lenis.scrollTo(0, { duration: 1.2 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={toWaitlist}
      data-testid="shop-bar"
      className="group fixed bottom-0 left-0 right-0 z-40 flex items-center justify-center gap-3 md:gap-4 py-4 md:py-5 transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]"
      style={{
        background: "var(--paper)",
        color: "var(--cream)",
        transform: show ? "translateY(0)" : "translateY(100%)",
        borderTop: "1px solid rgba(255,255,255,0.12)",
      }}
    >
      <span className="text-[0.66rem] md:text-[0.74rem] track-sm uppercase font-semibold">
        Join the waitlist
      </span>
      <ArrowRight
        size={16}
        className="transition-transform duration-300 group-hover:translate-x-1.5"
      />
    </button>
  );
}
